import { observer } from 'mobx-react';
import { OneToolQuoteStepper } from './components/oneToolQuoteStepper';
import { useOneToolStore } from './hooks/useOneToolStore';
import { BorrowerInformationStep } from './steps/borrowerInformation/borrowerInformationStep';
import { StabilizedBridgePropertyInformationForm } from './steps/propertyInformation/forms/stabilizedBridgePropertyInformationForm';
import { PropertyInformationStep } from './steps/propertyInformation/propertyInformationStep';
import { SummaryStep } from './steps/summary/summaryStep';
import { PreflightStep } from './steps/preflight/preflightStep';
import { LoanSuccessStep } from './steps/common/loanSuccess';
import { useEffect } from 'react';
import { EntityInformationStep } from './steps/entityInformation/entityInformationStep';
import { SinglePropertyRentalLoanEconomicsStore } from './stores/loanEconomics/singlePropertyRentalLoanEconomicsStore';
import { SinglePropertyRentalPropertyInformationForm } from './steps/propertyInformation/forms/singlePropertyRentalPropertyInformationForm';
import { SinglePropertyRentalLoanDetailsCard } from './steps/loanEconomics/components/singlePropertyRentalLoanDetailsCard';
import { insertIf } from '@roc/feature-utils';
import { PricerSummaryTermV2 } from './steps/loanPricer/pricerSummaryTermV2';

export const SinglePropertyRentalQuote = observer(() => {
  const { oneToolStore } = useOneToolStore();
  const { singlePropertyRentalQuoteStore } = oneToolStore;

  useEffect(() => {
    const loanEconomicsStore = singlePropertyRentalQuoteStore.loanEconomicsStore as SinglePropertyRentalLoanEconomicsStore;
    loanEconomicsStore.fetchExitRate();
  }, []);

  const steps: JSX.Element[] = [
    <EntityInformationStep key="entity" />,
    <BorrowerInformationStep key="borrower" store={singlePropertyRentalQuoteStore} />,
    <PropertyInformationStep
      key="property"
      disableAddMoreProperties={true}
      store={singlePropertyRentalQuoteStore}
      PropertyInformationForm={SinglePropertyRentalPropertyInformationForm}
    />,
    ...insertIf(singlePropertyRentalQuoteStore.allowPricerStep, [
      <PricerSummaryTermV2
        key="pricer"
        store={singlePropertyRentalQuoteStore}
      />,
    ]),
    <SummaryStep
      key="summary"
      store={singlePropertyRentalQuoteStore}
      LoanDetailsCard={SinglePropertyRentalLoanDetailsCard}
    />
  ];

  const title = singlePropertyRentalQuoteStore.isEditingLoan ? ` Edit Single Property Rental Loan #${singlePropertyRentalQuoteStore.loanId}` : 'Create a Quote - Single Property Rental Loan';

  return (
    <OneToolQuoteStepper
      title={title}
      store={singlePropertyRentalQuoteStore}
      preflightStep={
        <PreflightStep
          store={singlePropertyRentalQuoteStore}
          LoanDetailsCard={SinglePropertyRentalLoanDetailsCard}
          PropertyInformationForm={StabilizedBridgePropertyInformationForm}
        />
      }
      successStep={<LoanSuccessStep store={singlePropertyRentalQuoteStore} />}
    >
      {steps}
    </OneToolQuoteStepper>
  );
});
